"use client"
import '../../css/quickBooking.css';
import '../../css/overlay.css';
import { createBooking } from '../../api/booking-api'
import React, { useState } from 'react';
import { formatDateToTime } from '../../utils/dateTimeUtils';
import PinField from "react-pin-field";
import { QRCodeSVG } from 'qrcode.react';
import CountdownTimer from '../timer';
import { useToast } from '../../providers/toastProvider';
import { useLanguage } from '../../providers/preferenceProvider';


export const QuickBooking = ({ isOpen, onClose, startTime, endTime, room, systemId, qrCodeUrl }) => {
  const { showToast, showLoading, hideLoading } = useToast();
  const [tempPin, setTempPin] = useState("");
  const [showConfirm, setShowConfirm] = useState(false);
  const { t } = useLanguage();

  if (!startTime || !isOpen || !endTime) return null;
  const start = new Date(startTime);
  const end = new Date(endTime);

  const confirmPin = async () => {
    setShowConfirm(false);
    //TODO don't allow to many clicks because server times out
    try {
      showLoading();
      await createBooking(
        systemId,
        {
          title: "Quick Booking",
          roomId: room.id,
          startTime: start,
          endTime: end,
          description: "Made using quick book",
          personalCode: tempPin,
        }
      );
      setTempPin("");
      onClose();
      showToast("Quick Booking Successful","success");
      hideLoading();
    } catch (error) {
      console.error("Booking failed:", error); 
      hideLoading();
    }
  };


  return (
    <div className="overlay-backdrop" onClick={onClose}>
      <div
        className="overlay-content-quick-book"
        onClick={(e) => e.stopPropagation()}
        style={{ position: "relative" }}
      >
        {/* Countdown Timer UI */}
        {isOpen && (
          <CountdownTimer duration={20} onExpire={onClose} />
        )}

        <div className="overlay-title">
          {t.display.book} '{room.name}' {t.display.from} {formatDateToTime(start)} {t.display.to} {formatDateToTime(end)}
        </div>

        <div className="make-quick-book">
          {/* PIN Code Section */}
          <div className="digit-code">
            <div className="option-text-pin option-text"> {t.display.signInPC}</div>
            <div className="num-pad">
              <div className="pin-input">
                <PinField
                  length={5}
                  format={(char) => /^[0-9]$/.test(char) ? char : ""}
                  inputMode="numeric"
                  pattern="[0-9]*"
                  onChange={(value) => {
                    const allValid = /^[0-9]{5}$/.test(value);
                    setTempPin(value);
                    setShowConfirm(allValid);
                  }}
                />
              </div>
              {showConfirm && (
                <button onClick={confirmPin} className="confirm-button">
                  {t.display.confirmBooking}
                </button>
              )}
            </div>
          </div>

          <div className="dividing-line"></div>

          {/* QR Code Section */}
          <div className="qr-code" style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            <div className="option-text-qr option-text"> {t.display.signInQR}</div>
            {qrCodeUrl ? (
              <QRCodeSVG value={qrCodeUrl} size={220} level="H" includeMargin={true} />
            ) : (
              <div> {t.display.qrUnavailable}</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuickBooking;
